import {
  GET_COMBO_USER,
  GET_COMBO_USER_SUCCESS,
  GET_COMBO_USER_FAILURE,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAILURE,
} from "actions/User/actionTypes";

const initialState = {
  getComboUserLoading: false,
  combo: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
  currentUser: {},
};

const getComboUser = (state, action) => ({
  ...state,
  getComboUserLoading: true,
});

const getComboUserSuccess = (state, action) => {
  return {
    ...state,
    getComboUserLoading: false,
    combo: action.payload,
  };
};

const getComboUserFailed = (state, action) => ({
  ...state,
  getComboUserLoading: false,
  combo: [],
});
const getCurrentUser = (state, action) => ({
  ...state,
  getCurrentUserLoading: true,
});

const getCurrentUserSuccess = (state, action) => {
  return {
    ...state,
    getCurrentUserLoading: false,
    currentUser: action.payload,
  };
};

const getCurrentUserFailed = (state, action) => ({
  ...state,
  getCurrentUserLoading: false,
  combo: [],
});

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_USER:
      return getComboUser(state, action);
    case GET_COMBO_USER_SUCCESS:
      return getComboUserSuccess(state, action);
    case GET_COMBO_USER_FAILURE:
      return getComboUserFailed(state, action);
    case GET_CURRENT_USER:
      return getCurrentUser(state, action);
    case GET_CURRENT_USER_SUCCESS:
      return getCurrentUserSuccess(state, action);
    case GET_CURRENT_USER_FAILURE:
      return getCurrentUserFailed(state, action);
    default:
      return state;
  }
};

export default userReducer;
